import AbstractElement from "./AbstractElement";
import QuestionHelper from "../helper/QuestionHelper";
import {ViewEvent} from "../event/EventStaus";

class QFormElement extends AbstractElement {

    constructor(template: JQuery) {
        super(template);
    }

    init(): void {

    }


}

export default QFormElement;